import gqlTagGira from 'graphql-tag';

export const PROJECT_ACTORS = gqlTagGira`
    query ProjectActorsQuery($filter: ProjectActorInputs, $projectId: Long!) {
        projectActors(filter: $filter, projectId: $projectId) {
            actors {
                email
                avatarUrl
                active
                accountId
                roleTypeId
                type
                displayName
                roles
                __typename
            }
            isLastBatch
            __typename
        }
    }
`;
